/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as AppSalesRouteImport } from './routes/app.sales'
import { Route as AppListingsRouteImport } from './routes/app.listings'
import { Route as AppLeadsRouteImport } from './routes/app.leads'
import { Route as AppInventoryRouteImport } from './routes/app.inventory'
import { Route as AppCustomersRouteImport } from './routes/app.customers'
import { Route as AppGarageIndexRouteImport } from './routes/app.garage.index'
import { Route as AppSettingsChannelsRouteImport } from './routes/app.settings.channels'
import { Route as AppInventoryVisualRouteImport } from './routes/app.inventory_.visual'

const TermsLazyRouteImport = createFileRoute('/terms')()
const PrivacyLazyRouteImport = createFileRoute('/privacy')()
const IndexLazyRouteImport = createFileRoute('/')()
const OnboardingIndexLazyRouteImport = createFileRoute('/onboarding/')()
const AppIndexLazyRouteImport = createFileRoute('/app/')()
const OnboardingOrgLazyRouteImport = createFileRoute('/onboarding/org')()
const OnboardingLocationLazyRouteImport = createFileRoute(
  '/onboarding/location',
)()
const InviteTokenLazyRouteImport = createFileRoute('/invite/$token')()
const AuthSignupLazyRouteImport = createFileRoute('/auth/signup')()
const AuthLogoutLazyRouteImport = createFileRoute('/auth/logout')()
const AuthLoginLazyRouteImport = createFileRoute('/auth/login')()
const AuthForgotPasswordLazyRouteImport = createFileRoute(
  '/auth/forgot-password',
)()
const AppPullListLazyRouteImport = createFileRoute('/app/pull-list')()
const AppDashboardLazyRouteImport = createFileRoute('/app/dashboard')()
const AuthVerifyEmailIndexLazyRouteImport = createFileRoute(
  '/auth/verify-email/',
)()
const AppSettingsIndexLazyRouteImport = createFileRoute('/app/settings/')()
const AuthVerifyEmailTokenLazyRouteImport = createFileRoute(
  '/auth/verify-email/$token',
)()
const AppSettingsTeamLazyRouteImport = createFileRoute('/app/settings/team')()
const AppSettingsStorefrontLazyRouteImport = createFileRoute(
  '/app/settings/storefront',
)()
const AppSettingsSecurityLazyRouteImport = createFileRoute(
  '/app/settings/security',
)()
const AppSettingsSavedRepliesLazyRouteImport = createFileRoute(
  '/app/settings/saved-replies',
)()
const AppSettingsProfileLazyRouteImport = createFileRoute(
  '/app/settings/profile',
)()
const AppSettingsNotificationsLazyRouteImport = createFileRoute(
  '/app/settings/notifications',
)()
const AppSettingsLocationsLazyRouteImport = createFileRoute(
  '/app/settings/locations',
)()
const AppSettingsBusinessLazyRouteImport = createFileRoute(
  '/app/settings/business',
)()
const AppSettingsBillingLazyRouteImport = createFileRoute(
  '/app/settings/billing',
)()
const AppGarageDonorIdLazyRouteImport = createFileRoute(
  '/app/garage/$donorId',
)()
const AppCustomersCustomerIdLazyRouteImport = createFileRoute(
  '/app/customers/$customerId',
)()
const AuthResetPasswordUidTokenLazyRouteImport = createFileRoute(
  '/auth/reset-password/$uid/$token',
)()

const TermsLazyRoute = TermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))
const PrivacyLazyRoute = PrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/privacy.lazy').then((d) => d.Route))
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const OnboardingIndexLazyRoute = OnboardingIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding.index.lazy').then((d) => d.Route),
)
const AppIndexLazyRoute = AppIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.index.lazy').then((d) => d.Route))
const OnboardingOrgLazyRoute = OnboardingOrgLazyRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding.org.lazy').then((d) => d.Route),
)
const OnboardingLocationLazyRoute = OnboardingLocationLazyRouteImport.update({
  id: '/location',
  path: '/location',
  getParentRoute: () => OnboardingRoute,
} as any).lazy(() =>
  import('./routes/onboarding.location.lazy').then((d) => d.Route),
)
const InviteTokenLazyRoute = InviteTokenLazyRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/invite.$token.lazy').then((d) => d.Route))
const AuthSignupLazyRoute = AuthSignupLazyRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.signup.lazy').then((d) => d.Route))
const AuthLogoutLazyRoute = AuthLogoutLazyRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.logout.lazy').then((d) => d.Route))
const AuthLoginLazyRoute = AuthLoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.login.lazy').then((d) => d.Route))
const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/auth.forgot-password.lazy').then((d) => d.Route),
)
const AppPullListLazyRoute = AppPullListLazyRouteImport.update({
  id: '/pull-list',
  path: '/pull-list',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.pull-list.lazy').then((d) => d.Route))
const AppDashboardLazyRoute = AppDashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.dashboard.lazy').then((d) => d.Route))
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.sales.lazy').then((d) => d.Route))
const AppListingsRoute = AppListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.listings.lazy').then((d) => d.Route))
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.leads.lazy').then((d) => d.Route))
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.inventory.lazy').then((d) => d.Route))
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/app.customers.lazy').then((d) => d.Route))
const AuthVerifyEmailIndexLazyRoute =
  AuthVerifyEmailIndexLazyRouteImport.update({
    id: '/verify-email/',
    path: '/verify-email/',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/auth.verify-email.index.lazy').then((d) => d.Route),
  )
const AppSettingsIndexLazyRoute = AppSettingsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.index.lazy').then((d) => d.Route),
)
const AppGarageIndexRoute = AppGarageIndexRouteImport.update({
  id: '/garage/',
  path: '/garage/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app.garage.index.lazy').then((d) => d.Route),
)
const AuthVerifyEmailTokenLazyRoute =
  AuthVerifyEmailTokenLazyRouteImport.update({
    id: '/verify-email/$token',
    path: '/verify-email/$token',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/auth.verify-email.$token.lazy').then((d) => d.Route),
  )
const AppSettingsTeamLazyRoute = AppSettingsTeamLazyRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.team.lazy').then((d) => d.Route),
)
const AppSettingsStorefrontLazyRoute =
  AppSettingsStorefrontLazyRouteImport.update({
    id: '/storefront',
    path: '/storefront',
    getParentRoute: () => AppSettingsRoute,
  } as any).lazy(() =>
    import('./routes/app.settings.storefront.lazy').then((d) => d.Route),
  )
const AppSettingsSecurityLazyRoute = AppSettingsSecurityLazyRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.security.lazy').then((d) => d.Route),
)
const AppSettingsSavedRepliesLazyRoute =
  AppSettingsSavedRepliesLazyRouteImport.update({
    id: '/saved-replies',
    path: '/saved-replies',
    getParentRoute: () => AppSettingsRoute,
  } as any).lazy(() =>
    import('./routes/app.settings.saved-replies.lazy').then((d) => d.Route),
  )
const AppSettingsProfileLazyRoute = AppSettingsProfileLazyRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.profile.lazy').then((d) => d.Route),
)
const AppSettingsNotificationsLazyRoute =
  AppSettingsNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any).lazy(() =>
    import('./routes/app.settings.notifications.lazy').then((d) => d.Route),
  )
const AppSettingsLocationsLazyRoute =
  AppSettingsLocationsLazyRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AppSettingsRoute,
  } as any).lazy(() =>
    import('./routes/app.settings.locations.lazy').then((d) => d.Route),
  )
const AppSettingsBusinessLazyRoute = AppSettingsBusinessLazyRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.business.lazy').then((d) => d.Route),
)
const AppSettingsBillingLazyRoute = AppSettingsBillingLazyRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.billing.lazy').then((d) => d.Route),
)
const AppGarageDonorIdLazyRoute = AppGarageDonorIdLazyRouteImport.update({
  id: '/garage/$donorId',
  path: '/garage/$donorId',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app.garage.$donorId.lazy').then((d) => d.Route),
)
const AppCustomersCustomerIdLazyRoute =
  AppCustomersCustomerIdLazyRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => AppCustomersRoute,
  } as any).lazy(() =>
    import('./routes/app.customers.$customerId.lazy').then((d) => d.Route),
  )
const AppSettingsChannelsRoute = AppSettingsChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AppSettingsRoute,
} as any).lazy(() =>
  import('./routes/app.settings.channels.lazy').then((d) => d.Route),
)
const AppInventoryVisualRoute = AppInventoryVisualRouteImport.update({
  id: '/inventory_/visual',
  path: '/inventory/visual',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app.inventory_.visual.lazy').then((d) => d.Route),
)
const AuthResetPasswordUidTokenLazyRoute =
  AuthResetPasswordUidTokenLazyRouteImport.update({
    id: '/reset-password/$uid/$token',
    path: '/reset-password/$uid/$token',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/auth.reset-password.$uid.$token.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/app/customers': typeof AppCustomersRouteWithChildren
  '/app/inventory': typeof AppInventoryRoute
  '/app/leads': typeof AppLeadsRoute
  '/app/listings': typeof AppListingsRoute
  '/app/sales': typeof AppSalesRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/dashboard': typeof AppDashboardLazyRoute
  '/app/pull-list': typeof AppPullListLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/signup': typeof AuthSignupLazyRoute
  '/invite/$token': typeof InviteTokenLazyRoute
  '/onboarding/location': typeof OnboardingLocationLazyRoute
  '/onboarding/org': typeof OnboardingOrgLazyRoute
  '/app/': typeof AppIndexLazyRoute
  '/onboarding/': typeof OnboardingIndexLazyRoute
  '/app/inventory/visual': typeof AppInventoryVisualRoute
  '/app/settings/channels': typeof AppSettingsChannelsRoute
  '/app/customers/$customerId': typeof AppCustomersCustomerIdLazyRoute
  '/app/garage/$donorId': typeof AppGarageDonorIdLazyRoute
  '/app/settings/billing': typeof AppSettingsBillingLazyRoute
  '/app/settings/business': typeof AppSettingsBusinessLazyRoute
  '/app/settings/locations': typeof AppSettingsLocationsLazyRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsLazyRoute
  '/app/settings/profile': typeof AppSettingsProfileLazyRoute
  '/app/settings/saved-replies': typeof AppSettingsSavedRepliesLazyRoute
  '/app/settings/security': typeof AppSettingsSecurityLazyRoute
  '/app/settings/storefront': typeof AppSettingsStorefrontLazyRoute
  '/app/settings/team': typeof AppSettingsTeamLazyRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenLazyRoute
  '/app/garage/': typeof AppGarageIndexRoute
  '/app/settings/': typeof AppSettingsIndexLazyRoute
  '/auth/verify-email/': typeof AuthVerifyEmailIndexLazyRoute
  '/auth/reset-password/$uid/$token': typeof AuthResetPasswordUidTokenLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/auth': typeof AuthRouteWithChildren
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/app/customers': typeof AppCustomersRouteWithChildren
  '/app/inventory': typeof AppInventoryRoute
  '/app/leads': typeof AppLeadsRoute
  '/app/listings': typeof AppListingsRoute
  '/app/sales': typeof AppSalesRoute
  '/app/dashboard': typeof AppDashboardLazyRoute
  '/app/pull-list': typeof AppPullListLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/signup': typeof AuthSignupLazyRoute
  '/invite/$token': typeof InviteTokenLazyRoute
  '/onboarding/location': typeof OnboardingLocationLazyRoute
  '/onboarding/org': typeof OnboardingOrgLazyRoute
  '/app': typeof AppIndexLazyRoute
  '/onboarding': typeof OnboardingIndexLazyRoute
  '/app/inventory/visual': typeof AppInventoryVisualRoute
  '/app/settings/channels': typeof AppSettingsChannelsRoute
  '/app/customers/$customerId': typeof AppCustomersCustomerIdLazyRoute
  '/app/garage/$donorId': typeof AppGarageDonorIdLazyRoute
  '/app/settings/billing': typeof AppSettingsBillingLazyRoute
  '/app/settings/business': typeof AppSettingsBusinessLazyRoute
  '/app/settings/locations': typeof AppSettingsLocationsLazyRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsLazyRoute
  '/app/settings/profile': typeof AppSettingsProfileLazyRoute
  '/app/settings/saved-replies': typeof AppSettingsSavedRepliesLazyRoute
  '/app/settings/security': typeof AppSettingsSecurityLazyRoute
  '/app/settings/storefront': typeof AppSettingsStorefrontLazyRoute
  '/app/settings/team': typeof AppSettingsTeamLazyRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenLazyRoute
  '/app/garage': typeof AppGarageIndexRoute
  '/app/settings': typeof AppSettingsIndexLazyRoute
  '/auth/verify-email': typeof AuthVerifyEmailIndexLazyRoute
  '/auth/reset-password/$uid/$token': typeof AuthResetPasswordUidTokenLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyLazyRoute
  '/terms': typeof TermsLazyRoute
  '/app/customers': typeof AppCustomersRouteWithChildren
  '/app/inventory': typeof AppInventoryRoute
  '/app/leads': typeof AppLeadsRoute
  '/app/listings': typeof AppListingsRoute
  '/app/sales': typeof AppSalesRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/dashboard': typeof AppDashboardLazyRoute
  '/app/pull-list': typeof AppPullListLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/auth/signup': typeof AuthSignupLazyRoute
  '/invite/$token': typeof InviteTokenLazyRoute
  '/onboarding/location': typeof OnboardingLocationLazyRoute
  '/onboarding/org': typeof OnboardingOrgLazyRoute
  '/app/': typeof AppIndexLazyRoute
  '/onboarding/': typeof OnboardingIndexLazyRoute
  '/app/inventory_/visual': typeof AppInventoryVisualRoute
  '/app/settings/channels': typeof AppSettingsChannelsRoute
  '/app/customers/$customerId': typeof AppCustomersCustomerIdLazyRoute
  '/app/garage/$donorId': typeof AppGarageDonorIdLazyRoute
  '/app/settings/billing': typeof AppSettingsBillingLazyRoute
  '/app/settings/business': typeof AppSettingsBusinessLazyRoute
  '/app/settings/locations': typeof AppSettingsLocationsLazyRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsLazyRoute
  '/app/settings/profile': typeof AppSettingsProfileLazyRoute
  '/app/settings/saved-replies': typeof AppSettingsSavedRepliesLazyRoute
  '/app/settings/security': typeof AppSettingsSecurityLazyRoute
  '/app/settings/storefront': typeof AppSettingsStorefrontLazyRoute
  '/app/settings/team': typeof AppSettingsTeamLazyRoute
  '/auth/verify-email/$token': typeof AuthVerifyEmailTokenLazyRoute
  '/app/garage/': typeof AppGarageIndexRoute
  '/app/settings/': typeof AppSettingsIndexLazyRoute
  '/auth/verify-email/': typeof AuthVerifyEmailIndexLazyRoute
  '/auth/reset-password/$uid/$token': typeof AuthResetPasswordUidTokenLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/auth'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/app/customers'
    | '/app/inventory'
    | '/app/leads'
    | '/app/listings'
    | '/app/sales'
    | '/app/settings'
    | '/app/dashboard'
    | '/app/pull-list'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/invite/$token'
    | '/onboarding/location'
    | '/onboarding/org'
    | '/app/'
    | '/onboarding/'
    | '/app/inventory/visual'
    | '/app/settings/channels'
    | '/app/customers/$customerId'
    | '/app/garage/$donorId'
    | '/app/settings/billing'
    | '/app/settings/business'
    | '/app/settings/locations'
    | '/app/settings/notifications'
    | '/app/settings/profile'
    | '/app/settings/saved-replies'
    | '/app/settings/security'
    | '/app/settings/storefront'
    | '/app/settings/team'
    | '/auth/verify-email/$token'
    | '/app/garage/'
    | '/app/settings/'
    | '/auth/verify-email/'
    | '/auth/reset-password/$uid/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/privacy'
    | '/terms'
    | '/app/customers'
    | '/app/inventory'
    | '/app/leads'
    | '/app/listings'
    | '/app/sales'
    | '/app/dashboard'
    | '/app/pull-list'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/invite/$token'
    | '/onboarding/location'
    | '/onboarding/org'
    | '/app'
    | '/onboarding'
    | '/app/inventory/visual'
    | '/app/settings/channels'
    | '/app/customers/$customerId'
    | '/app/garage/$donorId'
    | '/app/settings/billing'
    | '/app/settings/business'
    | '/app/settings/locations'
    | '/app/settings/notifications'
    | '/app/settings/profile'
    | '/app/settings/saved-replies'
    | '/app/settings/security'
    | '/app/settings/storefront'
    | '/app/settings/team'
    | '/auth/verify-email/$token'
    | '/app/garage'
    | '/app/settings'
    | '/auth/verify-email'
    | '/auth/reset-password/$uid/$token'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/auth'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/app/customers'
    | '/app/inventory'
    | '/app/leads'
    | '/app/listings'
    | '/app/sales'
    | '/app/settings'
    | '/app/dashboard'
    | '/app/pull-list'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/signup'
    | '/invite/$token'
    | '/onboarding/location'
    | '/onboarding/org'
    | '/app/'
    | '/onboarding/'
    | '/app/inventory_/visual'
    | '/app/settings/channels'
    | '/app/customers/$customerId'
    | '/app/garage/$donorId'
    | '/app/settings/billing'
    | '/app/settings/business'
    | '/app/settings/locations'
    | '/app/settings/notifications'
    | '/app/settings/profile'
    | '/app/settings/saved-replies'
    | '/app/settings/security'
    | '/app/settings/storefront'
    | '/app/settings/team'
    | '/auth/verify-email/$token'
    | '/app/garage/'
    | '/app/settings/'
    | '/auth/verify-email/'
    | '/auth/reset-password/$uid/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PrivacyLazyRoute: typeof PrivacyLazyRoute
  TermsLazyRoute: typeof TermsLazyRoute
  InviteTokenLazyRoute: typeof InviteTokenLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexLazyRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/org': {
      id: '/onboarding/org'
      path: '/org'
      fullPath: '/onboarding/org'
      preLoaderRoute: typeof OnboardingOrgLazyRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/location': {
      id: '/onboarding/location'
      path: '/location'
      fullPath: '/onboarding/location'
      preLoaderRoute: typeof OnboardingLocationLazyRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/pull-list': {
      id: '/app/pull-list'
      path: '/pull-list'
      fullPath: '/app/pull-list'
      preLoaderRoute: typeof AppPullListLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/sales': {
      id: '/app/sales'
      path: '/sales'
      fullPath: '/app/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/listings': {
      id: '/app/listings'
      path: '/listings'
      fullPath: '/app/listings'
      preLoaderRoute: typeof AppListingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/leads': {
      id: '/app/leads'
      path: '/leads'
      fullPath: '/app/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/inventory': {
      id: '/app/inventory'
      path: '/inventory'
      fullPath: '/app/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/customers': {
      id: '/app/customers'
      path: '/customers'
      fullPath: '/app/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/verify-email/': {
      id: '/auth/verify-email/'
      path: '/verify-email'
      fullPath: '/auth/verify-email/'
      preLoaderRoute: typeof AuthVerifyEmailIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/garage/': {
      id: '/app/garage/'
      path: '/garage'
      fullPath: '/app/garage/'
      preLoaderRoute: typeof AppGarageIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/verify-email/$token': {
      id: '/auth/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/auth/verify-email/$token'
      preLoaderRoute: typeof AuthVerifyEmailTokenLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/settings/team': {
      id: '/app/settings/team'
      path: '/team'
      fullPath: '/app/settings/team'
      preLoaderRoute: typeof AppSettingsTeamLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/storefront': {
      id: '/app/settings/storefront'
      path: '/storefront'
      fullPath: '/app/settings/storefront'
      preLoaderRoute: typeof AppSettingsStorefrontLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/security': {
      id: '/app/settings/security'
      path: '/security'
      fullPath: '/app/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/saved-replies': {
      id: '/app/settings/saved-replies'
      path: '/saved-replies'
      fullPath: '/app/settings/saved-replies'
      preLoaderRoute: typeof AppSettingsSavedRepliesLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/profile': {
      id: '/app/settings/profile'
      path: '/profile'
      fullPath: '/app/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/notifications': {
      id: '/app/settings/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/locations': {
      id: '/app/settings/locations'
      path: '/locations'
      fullPath: '/app/settings/locations'
      preLoaderRoute: typeof AppSettingsLocationsLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/business': {
      id: '/app/settings/business'
      path: '/business'
      fullPath: '/app/settings/business'
      preLoaderRoute: typeof AppSettingsBusinessLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/billing': {
      id: '/app/settings/billing'
      path: '/billing'
      fullPath: '/app/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingLazyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/garage/$donorId': {
      id: '/app/garage/$donorId'
      path: '/garage/$donorId'
      fullPath: '/app/garage/$donorId'
      preLoaderRoute: typeof AppGarageDonorIdLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/customers/$customerId': {
      id: '/app/customers/$customerId'
      path: '/$customerId'
      fullPath: '/app/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdLazyRouteImport
      parentRoute: typeof AppCustomersRoute
    }
    '/app/settings/channels': {
      id: '/app/settings/channels'
      path: '/channels'
      fullPath: '/app/settings/channels'
      preLoaderRoute: typeof AppSettingsChannelsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/inventory_/visual': {
      id: '/app/inventory_/visual'
      path: '/inventory/visual'
      fullPath: '/app/inventory/visual'
      preLoaderRoute: typeof AppInventoryVisualRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/reset-password/$uid/$token': {
      id: '/auth/reset-password/$uid/$token'
      path: '/reset-password/$uid/$token'
      fullPath: '/auth/reset-password/$uid/$token'
      preLoaderRoute: typeof AuthResetPasswordUidTokenLazyRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AppCustomersRouteChildren {
  AppCustomersCustomerIdLazyRoute: typeof AppCustomersCustomerIdLazyRoute
}

const AppCustomersRouteChildren: AppCustomersRouteChildren = {
  AppCustomersCustomerIdLazyRoute: AppCustomersCustomerIdLazyRoute,
}

const AppCustomersRouteWithChildren = AppCustomersRoute._addFileChildren(
  AppCustomersRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsChannelsRoute: typeof AppSettingsChannelsRoute
  AppSettingsBillingLazyRoute: typeof AppSettingsBillingLazyRoute
  AppSettingsBusinessLazyRoute: typeof AppSettingsBusinessLazyRoute
  AppSettingsLocationsLazyRoute: typeof AppSettingsLocationsLazyRoute
  AppSettingsNotificationsLazyRoute: typeof AppSettingsNotificationsLazyRoute
  AppSettingsProfileLazyRoute: typeof AppSettingsProfileLazyRoute
  AppSettingsSavedRepliesLazyRoute: typeof AppSettingsSavedRepliesLazyRoute
  AppSettingsSecurityLazyRoute: typeof AppSettingsSecurityLazyRoute
  AppSettingsStorefrontLazyRoute: typeof AppSettingsStorefrontLazyRoute
  AppSettingsTeamLazyRoute: typeof AppSettingsTeamLazyRoute
  AppSettingsIndexLazyRoute: typeof AppSettingsIndexLazyRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsChannelsRoute: AppSettingsChannelsRoute,
  AppSettingsBillingLazyRoute: AppSettingsBillingLazyRoute,
  AppSettingsBusinessLazyRoute: AppSettingsBusinessLazyRoute,
  AppSettingsLocationsLazyRoute: AppSettingsLocationsLazyRoute,
  AppSettingsNotificationsLazyRoute: AppSettingsNotificationsLazyRoute,
  AppSettingsProfileLazyRoute: AppSettingsProfileLazyRoute,
  AppSettingsSavedRepliesLazyRoute: AppSettingsSavedRepliesLazyRoute,
  AppSettingsSecurityLazyRoute: AppSettingsSecurityLazyRoute,
  AppSettingsStorefrontLazyRoute: AppSettingsStorefrontLazyRoute,
  AppSettingsTeamLazyRoute: AppSettingsTeamLazyRoute,
  AppSettingsIndexLazyRoute: AppSettingsIndexLazyRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppCustomersRoute: typeof AppCustomersRouteWithChildren
  AppInventoryRoute: typeof AppInventoryRoute
  AppLeadsRoute: typeof AppLeadsRoute
  AppListingsRoute: typeof AppListingsRoute
  AppSalesRoute: typeof AppSalesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppDashboardLazyRoute: typeof AppDashboardLazyRoute
  AppPullListLazyRoute: typeof AppPullListLazyRoute
  AppIndexLazyRoute: typeof AppIndexLazyRoute
  AppInventoryVisualRoute: typeof AppInventoryVisualRoute
  AppGarageDonorIdLazyRoute: typeof AppGarageDonorIdLazyRoute
  AppGarageIndexRoute: typeof AppGarageIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCustomersRoute: AppCustomersRouteWithChildren,
  AppInventoryRoute: AppInventoryRoute,
  AppLeadsRoute: AppLeadsRoute,
  AppListingsRoute: AppListingsRoute,
  AppSalesRoute: AppSalesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppDashboardLazyRoute: AppDashboardLazyRoute,
  AppPullListLazyRoute: AppPullListLazyRoute,
  AppIndexLazyRoute: AppIndexLazyRoute,
  AppInventoryVisualRoute: AppInventoryVisualRoute,
  AppGarageDonorIdLazyRoute: AppGarageDonorIdLazyRoute,
  AppGarageIndexRoute: AppGarageIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  AuthLogoutLazyRoute: typeof AuthLogoutLazyRoute
  AuthSignupLazyRoute: typeof AuthSignupLazyRoute
  AuthVerifyEmailTokenLazyRoute: typeof AuthVerifyEmailTokenLazyRoute
  AuthVerifyEmailIndexLazyRoute: typeof AuthVerifyEmailIndexLazyRoute
  AuthResetPasswordUidTokenLazyRoute: typeof AuthResetPasswordUidTokenLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  AuthLogoutLazyRoute: AuthLogoutLazyRoute,
  AuthSignupLazyRoute: AuthSignupLazyRoute,
  AuthVerifyEmailTokenLazyRoute: AuthVerifyEmailTokenLazyRoute,
  AuthVerifyEmailIndexLazyRoute: AuthVerifyEmailIndexLazyRoute,
  AuthResetPasswordUidTokenLazyRoute: AuthResetPasswordUidTokenLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OnboardingRouteChildren {
  OnboardingLocationLazyRoute: typeof OnboardingLocationLazyRoute
  OnboardingOrgLazyRoute: typeof OnboardingOrgLazyRoute
  OnboardingIndexLazyRoute: typeof OnboardingIndexLazyRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingLocationLazyRoute: OnboardingLocationLazyRoute,
  OnboardingOrgLazyRoute: OnboardingOrgLazyRoute,
  OnboardingIndexLazyRoute: OnboardingIndexLazyRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  PrivacyLazyRoute: PrivacyLazyRoute,
  TermsLazyRoute: TermsLazyRoute,
  InviteTokenLazyRoute: InviteTokenLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
